<template>
  <div class="chart-box">
    <div class="chart-box-title">
      <img src="@/assets/images/echartTitleLogo.png" alt="" /><em>{{ title }}</em>
    </div>
    <div :id="id" class="echarts-class" v-if="id"></div>
    <slot></slot>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import 'echarts-gl'
import { markRaw } from "vue";
export default {
  props: {
    title: {
      type: String,
      default: 'echartsBox'
    },
    id: {
      type: String,
      default: ''
    },
  },
  name: 'echartsBox',
  data() {
    return {
      myCharts: null
    }
  },
  mounted() {

  },
  methods: {
    initEcharts(options) {
      this.myCharts = markRaw(echarts.init(document.getElementById(this.id)))
      this.myCharts.setOption(options)
      window.addEventListener('resize', () => {
        this.myCharts.resize()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.chart-box {
  height: 90%;
  width: 90%;
  display: flex;
  flex-direction: column;

  .chart-box-title {
    margin-left: 20px;
    height: 6.2vh;
    line-height: 1.3vh;
    padding: 0 0vw 0 0vw;
    background-image: url("../../../assets/images/parkBoxTopBg.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center bottom -0.5vh;
    font-size: 1.06vw;
    color: #fff;
    font-family: Alibaba-PuHuiTi-B;
    text-indent: 2.3em;
    margin-bottom: -2vh;

    img {
      width: auto;
      height: 20px;
      margin-top: 5px;
      margin-right: 5px;
    }

  }

  .echarts-class {
    flex: 1;
    transform: translateX(20px);
  }
}
</style>
